// extracted by mini-css-extract-plugin
export default {"root":"z6ccei","wired":"mJJb32"};